import { useContextStore, useContextStoreApi } from '../../../../utils/zustand'
import { ContextMenuStoreContext } from '../contexts/StoreContext'
import { ContextMenuExposedStore, ContextMenuStore } from '../store/interface'

export const useContextMenuStore = <T, StateSlice>(
  selector: (state: ContextMenuExposedStore<T>) => StateSlice
) => {
  return useContextStore<ContextMenuStore<T>, StateSlice>(
    ContextMenuStoreContext as any,
    selector
  )
}

export const useContextMenuStoreApi = <T>() => {
  return useContextStoreApi<ContextMenuStore<T>>(ContextMenuStoreContext as any)
}
